// extracted by mini-css-extract-plugin
export default {"ellipsizedText":"EllipsizableText_ellipsizedText__JSnKr"};